import styled, { css } from 'styled-components';
import { Icon as Icn } from 'src/components';

export const Button = styled.button.attrs({
  type: 'button',
})(
  ({ theme }) => css`
    &:hover {
      background-color: ${theme.co.neutral95};
      color: ${theme.co.secondary0};
    }

    &:disabled {
      cursor: not-allowed;
    }
  `,
);

export const IconWrapper = styled.button<{ $active?: boolean }>(
  ({ theme, $active }) => css`
    margin: 0;

    background-color: ${theme.co.neutral98};
    border-radius: ${theme.bo.round};
    border: 0;
    height: ${theme.sz.s10};
    width: ${theme.sz.s10};
    color: ${$active ? theme.co.secondary0 : theme.co.secondary60};
    cursor: pointer;

    &:hover {
      background-color: ${theme.co.neutral95};
      color: ${theme.co.secondary0};
    }

    &:disabled {
      cursor: not-allowed;
    }
  `,
);

export const Icon = styled(Icn)(
  ({ theme }) => css`
    font-size: ${theme.sz.s6};
    margin-left: ${theme.sz.s05};
  `,
);
